module.exports = __webpack_public_path__ + "static/img/bg-banner-bigdata.6201f27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bg-banner-bigdata.png
// module id = MnTb
// module chunks = 1